import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Check, Lock } from 'lucide-react';

// Time slot grid for the party deposit flow. Shows party-available slots
// (all standard rigs free + outside the 48h lead-time window) as selectable,
// and all other slots as disabled with appropriate visual states.
export default function PartyTimeSlotGrid({ slots, slotAvailability, selectedSlot, onSelectSlot }) {
  return (
    <motion.div key="slots" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
      <p className="text-primary text-xs font-bold tracking-widest mb-4 flex items-center gap-2">
        <Clock className="w-4 h-4" /> SELECT TIME
      </p>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {slots.map((slot) => {
          const sa = slotAvailability ? slotAvailability[slot] : { available: false, withinLeadTime: false, past: false };
          const isSelected = selectedSlot === slot;
          const isAvailable = sa.available;
          const isWithinLead = sa.withinLeadTime && !sa.past;
          const isPast = sa.past;

          let cls = 'border-white/5 bg-[#111115] text-white/20 cursor-not-allowed';
          let icon = null;
          if (isAvailable) {
            cls = isSelected
              ? 'border-primary bg-primary/10 text-primary'
              : 'border-white/10 bg-[#111115] text-white/70 hover:border-primary/40 hover:text-white cursor-pointer';
          } else if (isWithinLead) {
            icon = <Lock className="w-3 h-3" />;
            cls = 'border-white/5 bg-[#111115] text-white/15 cursor-not-allowed';
          }

          return (
            <button
              key={slot}
              type="button"
              disabled={!isAvailable}
              onClick={() => onSelectSlot(slot)}
              className={`relative flex items-center justify-center gap-1.5 border h-11 text-xs font-bold tracking-wider transition-colors ${cls}`}
            >
              {isSelected && <Check className="w-3 h-3" />}
              {icon}
              {slot}
            </button>
          );
        })}
      </div>
      <p className="text-white/20 text-xs mt-3">
        A slot is selectable only when <span className="text-emerald-500/70">all standard rigs are free</span> and the session
        is at least <span className="text-primary">48 hours away</span>. Locked slots are within the 48-hour window.
      </p>
    </motion.div>
  );
}